module.exports = __webpack_public_path__ + "static/img/strona_036.9b67806c.jpg";